import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/CartButton/cartButton.container"
    ).then((module) => ({
        default: module.CartButton
    }))
);
